export default [
  {
    regexPathname: /^\/account-detail(\/)?$/g,
    path: '/account-detail',
    title: 'Profil',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/calendar(\/)?$/g,
    path: '/calendar',
    title: 'Kalender',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/faq(\/)?$/g,
    path: '/faq',
    title: 'FAQ',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/faq-detail(\/)?$/g,
    path: '/faq-detail',
    title: 'FAQ',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/kyc(\/)?$/g,
    path: '/kyc',
    title: 'Verifikasi',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/margin-trading(\/)?/g,
    path: '/margin-trading',
    title: 'Margin Trading Transfer',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/margin-trading-activation(\/)?$/g,
    path: '/margin-trading-activation',
    title: 'Margin Trading Creation',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/margin-trading-onboarding(\/)?$/g,
    path: '/margin-trading-onboarding',
    title: 'Margin Trading Onboard',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/margin-trading-status(\/)?$/g,
    path: '/margin-trading-status',
    title: 'Margin Trading Status Account',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/market-index(\/)?$/g,
    path: '/market-index',
    title: 'Indeks',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/mutual-funds(\/)?$/g,
    path: '/mutual-funds',
    title: 'Discovery - Reksa Dana',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/news(\/)?$/g,
    path: '/news',
    title: 'Berita',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/pin(\/)?$/g,
    path: '/pin',
    title: 'PIN',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/portofolio$/g,
    path: '/portofolio',
    title: 'Portofolio Saham',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/portofolio\?tab=crypto/g,
    path: '/portofolio?tab=crypto',
    title: 'Portofolio Aset Kripto',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/portofolio\?tab=mutualFund/g,
    path: '/portofolio?tab=mutualFund',
    title: 'Portofolio Reksa Dana',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/portofolio\?tab=rightIssue/g,
    path: '/portofolio?tab=rightIssue',
    title: 'Portofolio HMETD',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/rdn(\/)?$/g,
    path: '/rdn',
    title: 'RDN',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/referral(\/)?$/g,
    path: '/referral',
    title: 'Referral',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/referral\/magic-carpet(\/)?$/g,
    path: '/referral/magic-carpet',
    title: 'Buka Hadiah',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/referral\/check-reward(\/)?$/g,
    path: '/referral/check-reward',
    title: 'Referral Cek Hadiah',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/reksadana(\/)/g,
    path: '/reksadana',
    title: 'Reksa Dana Detail',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/saham\/\w\w\w\w(\/)?$/g,
    path: '/saham',
    title: 'Detail Saham',
    codeIndex: 2,
  },
  {
    regexPathname: /^\/simulator(\/)?$/g,
    path: '/simulator',
    title: 'Kalkulator',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/stocks(\/)?$/g,
    path: '/stocks',
    title: 'Discovery - Saham',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/stocks\/highlight\/\w\w\w\w(\/)?$/g,
    path: '/stocks/highlight',
    title: 'Saham - Highlight',
    codeIndex: 3,
  },
  {
    regexPathname: /^\/stocks\/IPO\/\w\w\w\w(\/)?$/g,
    path: '/stocks/IPO',
    title: 'Saham - IPO',
    codeIndex: 3,
  },
  {
    regexPathname: /^\/transaction-auto-order(\/)?$/g,
    path: '/transaction-auto-order',
    title: 'Transaksi Auto Order',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/transaction-free-stock(\/)?$/g,
    path: '/transaction-free-stock',
    title: 'Transaksi Hadiah Saham',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/transaction-mutual-funds(\/)?$/g,
    path: '/transaction-mutual-funds',
    title: 'Transaksi Reksa Dana',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/transaction-stock(\/)?$/g,
    path: '/transaction-stock',
    title: 'Transaksi Saham',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/transaction-margin-trading(\/)?$/g,
    path: '/transaction-margin-trading',
    title: 'Transaksi Saham',
    codeIndex: 0,
  },
  {
    regexPathname: /^\/$/g,
    path: '/',
    title: 'Home',
    codeIndex: 0,
  },
];
